/**
 * 字符串书输出
 */
import fvAnimation from './fvAnimation';

export default class fvOutputChar extends fvAnimation {
    constructor(shape) {
        super(shape, 'fvOutputChar');
        this.shape.innerText = '';
        this.sizeFunction = AsyncFunction('return ' + this.expression);
    }

    async run(textDom) {
        var size = await this.executionScript(this.sizeFunction);
        if(size == '__defaule') {
            size = '...';
        }
        if(size != '' && size != undefined) {
            if(size.error) {
                return console.error(size.error);
            }
            //转译出来的 字符串多两个单引号， 用判断来去掉 “'name'”
            if(typeof size == 'number') {
                size = size.toString();
            }
            if(size.indexOf('\'') != -1) {
                size = size.substr(1, size.length - 2);
            }
            // textDom.firstChild.innerHTML = size;
            this.shape.innerText=size;
            this.shape.createStyle();
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvOutputChar.js